import { Image, Item } from '@conveyr/shared-types';
import { AxiosInstance } from 'axios';
import type { components, operations } from '@/api/generated/openapi';
import { axiosWithoutCaseMiddleware } from '@/helpers/forms/axios';

export type ImageResponse = components['schemas']['InventoryItemImage'];

// The server answers 201 when it creates the item's image and 200 when it
// replaces the existing one.
export type CreateInventoryItemImageResponse = operations['create-inventory-item-image']['responses']['200' | '201']['content']['application/json'];
export type DeleteInventoryItemImageResponse = operations['delete-inventory-item-image']['responses']['204']['content'];

export type CreateInventoryItemImageRequest = operations['create-inventory-item-image']['requestBody']['content']['application/json'];

export function toImage(inv: ImageResponse): Image {
    return {
        id: inv.id,
        largeUrl: inv.large_url,
        thumbnailUrl: inv.thumbnail_url,
    };
}

interface createItemImageFormInterface {
    thumbnailUrl: string
    largeUrl: string
}

export default (axios: AxiosInstance = axiosWithoutCaseMiddleware): { createItemImage: (item: Pick<Item, 'id'>, payload: createItemImageFormInterface) => Promise<Image>; deleteItemImage: (item: Pick<Item, 'id'>, imageId: number) => Promise<void>; } => ({
    createItemImage: async (item: Pick<Item, 'id'>, payload: createItemImageFormInterface): Promise<Image> => {
        const body: CreateInventoryItemImageRequest = {
            thumbnail_url: payload.thumbnailUrl,
            large_url: payload.largeUrl,
        };
        const response = await axios.post<CreateInventoryItemImageResponse>(`/api/inventory/${item.id}/images`, body);
        return toImage(response.data.data);
    },

    deleteItemImage: async (item: Pick<Item, 'id'>, imageId: number): Promise<void> => {
        await axios.delete<DeleteInventoryItemImageResponse>(`/api/inventory/${item.id}/images/${imageId}`);
    },
});
